export default __webpack_public_path__ + "static/media/09.8bb429e5.jpg";